import { FunctionComponent } from "react";
import { ErrorResponseResult } from "@adjust/website/libs/fetcher/errors";
import { Button, Col, Container, Row } from "react-bootstrap";
import { css } from "@adjust/libs/emotion";
import SiteLayout from "src/layouts/SiteLayout";
import NextLink from "@adjust/website/src/components/NextLink";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCompass, faArrowRight } from "@fortawesome/free-solid-svg-icons";

// ========================================
// Styles
// ========================================

const wrapper = css({
  minHeight: "70vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  padding: "2rem",
});

const content = css({
  maxWidth: "700px",
});

const icon = css({
  fontSize: "4.5rem",
  color: "#1f5fbf",
  marginBottom: "2rem",
});

const errorNumber = css({
  fontFamily: "Cormorant Garamond, serif",
  fontSize: "6rem",
  fontWeight: 700,
  color: "#1f355e",
  lineHeight: 1,
  marginBottom: "1rem",
});

const title = css({
  fontFamily: "Cormorant Garamond, serif",
  fontSize: "2.6rem",
  fontWeight: 600,
  color: "#1f355e",
  marginBottom: "1rem",
});

const subtitle = css({
  fontFamily: "Lato, sans-serif",
  fontSize: "1.15rem",
  lineHeight: 1.8,
  color: "#6b7280",
  margin: "0 auto 2.5rem",
  maxWidth: "560px",
});

const divider = css({
  width: "90px",
  height: "2px",
  background: "#d7e7ff",
  margin: "2rem auto",
});

const quote = css({
  marginTop: "3rem",
  fontFamily: "Cormorant Garamond, serif",
  fontSize: "1.35rem",
  fontStyle: "italic",
  color: "#7b8794",
});

// ========================================

const ErrorPage: FunctionComponent<ErrorResponseResult> = (p) => {
  return (
    <SiteLayout>
      <Container className={wrapper}>
        <div className={content}>
          <FontAwesomeIcon icon={faCompass} className={icon} />

          <div className={errorNumber}>{p.status || 404}</div>

          <h1 className={title}>This destination isn't on the map.</h1>

          <p className={subtitle}>
            {p.message ?? "The page you're looking for may have been moved, renamed, or never existed. Let's get you back to planning your next adventure."}
          </p>

          <div className={divider} />

          <Row className="g-3 justify-content-center mt-2">
            <Col xs={12} sm="auto">
              <NextLink href="/">
                <Button size="lg" className="w-100">
                  Return Home
                </Button>
              </NextLink>
            </Col>

            <Col xs={12} sm="auto">
              <NextLink href="/contact/">
                <Button variant="outline-primary" size="lg" className="w-100">
                  Contact a Travel Advisor
                  <FontAwesomeIcon icon={faArrowRight} className="ms-2" />
                </Button>
              </NextLink>
            </Col>
          </Row>

          <div className={quote}>"Life is better when you're traveling."</div>
        </div>
      </Container>
    </SiteLayout>
  );
};

export default ErrorPage;
